import { Mic } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function MicIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Mic
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
